import { render, staticRenderFns } from "./singleInsurance.vue?vue&type=template&id=d630bd20&scoped=true"
import script from "./singleInsurance.vue?vue&type=script&lang=js"
export * from "./singleInsurance.vue?vue&type=script&lang=js"
import style0 from "./singleInsurance.vue?vue&type=style&index=0&id=d630bd20&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630bd20",
  null
  
)

export default component.exports